import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { FormControlPipe } from "@bequeathed/ngx-utils";
import { BaseInputControl } from '../base-input-control/base-input-control.component';
import { NgClass } from "@angular/common";


/**
 * Basic text input field component with label, description element,
 * validation message area and the input element styling (feedback icon, border change)
 *
 * @author Dan Bennett (dbennett)
 */
@Component({
    selector: 'currency-control',
    templateUrl: './currency-control.component.html',
    styleUrls: [
        './currency-control.component.sass',
        '../base-input-control/base-input-control.component.sass',
        '../../base-form/base-form.component.sass'
    ],
    imports: [
        // Angular
        NgClass,
        ReactiveFormsModule,
        // Bequeathed
        FormControlPipe,
    ],
    standalone: true,
    encapsulation: ViewEncapsulation.None
})
export class CurrencyControl extends BaseInputControl implements OnInit {

    constructor() {
        super();

        this.inputType = 'number';
    }

    override ngOnInit(): void {
        this.validators = []
        this.validators.push(Validators.pattern(/^(0|[1-9]([0-9]*))$/));
        super.ngOnInit();

        if (this.editingResponse) {
            this.setPreviousResponse()
        }
    }
}
